export default __webpack_public_path__ + "static/media/GalleryFirstLogoFullSize.545d9353.jpg";